/* eslint-disable import/no-unresolved */
import { Col, Container, Row } from 'react-bootstrap';
import {
    Button, Modal, Radio, RadioGroup, TextArea,
} from 'appkit-react';
import closeIcons from 'assets/images/close-24px.svg';
import issueConfirmed from 'assets/images/issue-confirmed-icon.svg';
import noIssue from 'assets/images/no-issue-md.svg';
import reviewRequired from 'assets/images/review-required.svg';

const ClassifyResultModal = ({
    comment, setComment, radio, setRadio, showLoader, onClickClassify, setShowClassifyResult,
}) => (
    <Modal
        className="baseline-modal-showcase true-comply-classify__result__modal"
        visible
    >
        <Container className="true-comply-classify__result__modal-container">
            <Row className="true-comply-classify__result__modal-head-section">
                <Col sm={1} md={1}>
                    <img
                        src={closeIcons}
                        alt="modal close"
                        onClick={() => { setShowClassifyResult(false); }}
                        aria-hidden="true"
                        data-testid="set-page-name"
                    />
                </Col>
                <Col sm={10} md={10}>
                    <div className="true-comply-classify__result__modal-title">
                        ClassifyResult
                    </div>
                </Col>
                <Col sm={1} md={1}>
                    <Button
                        size="xl"
                        disabled={!comment}
                        onClick={() => onClickClassify()}
                        isLoading={showLoader}
                        data-testid="classify-btn"
                    >
                        Classify
                    </Button>
                </Col>
            </Row>
            <div className="border-bottom" />
            <div className="true-comply-classify__result__modal-body-section">
                <Row>
                    <Col
                        md={{ span: 7, offset: 2 }}
                        className="true-comply-classify__result__modal-body-section-title"
                    >
                        Classify Exceptions
                    </Col>
                </Row>
                <Row>
                    <Col md={{ span: 5, offset: 2 }}>
                        <p>
                            Review Required – Four eye check. Assign to another
                            resource for review .
                        </p>
                        <p>
                            {' '}
                            Issue Confirmed – Issue Confirmed, assign for remediation.
                        </p>
                        <p> No Issue – Not a real issue. False positive. </p>
                    </Col>
                    <Col md={{ span: 3 }}>
                        <div className="true-comply-classify__result__modal-body-section__img-continer">
                            <img
                                src={reviewRequired}
                                alt="Review Required"
                                aria-hidden="true"
                            />
                            <img
                                src={issueConfirmed}
                                alt="Issue Confirmed"
                                aria-hidden="true"
                            />
                            <img src={noIssue} alt="No Issue" aria-hidden="true" />
                        </div>
                    </Col>
                </Row>
                <Row className="true-comply-classify__result__modal-body-section__radio-group">
                    <Col
                        md={{ span: 4, offset: 2 }}
                        className="true-comply-classify__result__modal-body-section__radio-group-title"
                    >
                        Schedule Name
                    </Col>
                    <Col md={{ span: 4 }}>
                        <RadioGroup
                            name="radioname"
                            value={radio}
                            onChange={(event, value) => setRadio(value)}
                            data-testid="set-radio-name"
                        >
                            <Radio value="MARK_AS_REVIEW_REQUIRED">Review required</Radio>
                            <Radio value="MARK_AS_ISSUE">Issue confirmed</Radio>
                            <Radio value="MARK_AS_NO_ISSUE">No issue</Radio>
                        </RadioGroup>
                    </Col>
                </Row>
                <div className="secondary-input-container  a-apply-theme-background-gray-level-2">
                    <Row className="true-comply-classify__result__modal-body-section__comment-section">
                        <Col md={{ span: 4, offset: 2 }}>
                            <p>
                                Leave a comment
                                <span className="required-txt"> (required)</span>
                            </p>
                        </Col>
                        <Col md={{ span: 4 }}>
                            <TextArea
                                placeholder="Type here..."
                                className="fix-textarea"
                                value={comment}
                                onChange={value => setComment(value)}
                                data-testid="comment-change"
                            />
                            {!comment ? (
                                <p className="warn-txt">Please write comment.</p>
                            ) : (
                                <p className="warn-txt" />
                            )}
                        </Col>
                    </Row>
                </div>
            </div>
        </Container>
    </Modal>
);

export default ClassifyResultModal;
